import React from 'react';
import { Card, DatePicker, InputNumber, Row } from 'antd';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import UtinaCard from 'components/UtinaCard';
import GetLabel from 'DisplayFramework/components/GetLabel';

const parseN20_2 = (raw?: string): number => {
  if (!raw) {
    return 0;
  }

  const normalized = raw
    .replace(/\s+/g, '')
    .replace(',', '.')
    .replace(/[^0-9.]/g, '');

  if (normalized === '') {
    return 0;
  }

  const firstDotIndex = normalized.indexOf('.');
  const hasDot = firstDotIndex !== -1;

  const intPartRaw = hasDot ? normalized.slice(0, firstDotIndex) : normalized;
  const decPartRaw = hasDot ? normalized.slice(firstDotIndex + 1) : '';

  const intDigits = (intPartRaw.replace(/^0+(?=\d)/, '') || '0').slice(0, 20);
  const decDigits = decPartRaw.replace(/\./g, '').slice(0, 2);

  let result: string;
  if (!hasDot) {
    result = intDigits;
  } else {
    result = `${intDigits}.${decDigits}`;
  }

  return parseFloat(result) || 0;
};

export type IncomeProps = {
  form: FormInstance;
};

const IncomeCard = (props: IncomeProps) => {
  return (
    <Card
      bordered
      style={{ backgroundColor: '#f7f7f7' }}
      title={
        <GetLabel
          label="income"
          style={{ fontWeight: 'bold', paddingLeft: 15 }}
        />
      }
    >
      <Card>
        <Row gutter={16}>
          <UtinaCard comcode="employment" level={5} lg={8} additionalAttribute>
            <FormInput col xs={20} lg={20} name="tpemployer" />
            <FormInput col xs={20} lg={20} name="tpemloyertel">
              <InputNumber />
            </FormInput>
            <FormInput col xs={20} lg={20} name="tpemployeraddress" />
          </UtinaCard>

          <UtinaCard comcode="income" level={5} lg={8} additionalAttribute>
            <FormInput
              col
              xs={20}
              lg={20}
              name="tpmonthlyincome"
              rules={[
                {
                  required:
                    props.form.getFieldValue('tpflagclient') &&
                    props.form.getFieldValue('tpclienttype') === '2'
                      ? true
                      : false,
                },
              ]}
            >
              <InputNumber
                min={0}
                precision={2}
                parser={(value) => parseN20_2(value)}
              />
            </FormInput>
            <FormInput col xs={20} lg={20} name="tpothersincome">
              <InputNumber />
            </FormInput>
            <FormInput col xs={20} lg={20} name="tpfamilybenefits">
              <InputNumber />
            </FormInput>
          </UtinaCard>

          <UtinaCard comcode="expanses" level={5} lg={6} additionalAttribute>
            <FormInput col xs={20} name="tpotherloan">
              <InputNumber />
            </FormInput>
            <FormInput col xs={20} name="tpothersexpense">
              <InputNumber />
            </FormInput>
            <FormInput
              col
              xs={12}
              lg={12}
              name="tpincomedate"
              rules={[
                {
                  required:
                    props.form.getFieldValue('tpflagclient') &&
                    props.form.getFieldValue('tpclienttype') === '2'
                      ? true
                      : false,
                },
              ]}
            >
              <DatePicker />
            </FormInput>
          </UtinaCard>
        </Row>
      </Card>
    </Card>
  );
};

export default IncomeCard;
